import React from "react";
import CheckCircleInfoSmall from "shared/ui/svg-icons/CheckCircleInfoSmall";
import "./style.scss";

const LineStepper = ({ step }) => {
  return (
    <li>
      <div role="img" aria-hidden="true" className="center-icon">
        {step === "done" && <CheckCircleInfoSmall />}
        {step === "current" && (
          <div className="stepper-current primary-color-background" />
        )}
        {step === "next" && <div className="stepper-next" />}
      </div>
    </li>
  );
};

export default LineStepper;
